import { SETTINGS_LABEL_COPY } from "@fomofi/shared";
import {
  LayoutDashboard,
  ArrowLeftRight,
  PiggyBank,
  CalendarDays,
  Repeat,
  Target,
  TrendingUp,
  Lightbulb,
  ClipboardList,
  CreditCard,
  Wallet,
  Settings,
  type LucideIcon,
} from "lucide-react";

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
}

// Single source of truth for the main app nav — consumed by both the desktop
// persistent sidebar (AppSidebar) and the mobile drawer (MobileSidebar).
export const NAV_ITEMS: NavItem[] = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/transactions", label: "Transactions", icon: ArrowLeftRight },
  { to: "/budgets", label: "Budgets", icon: PiggyBank },
  { to: "/calendar", label: "Calendar", icon: CalendarDays },
  { to: "/goals", label: "Goals", icon: Target },
  { to: "/forecast", label: "Forecast", icon: TrendingUp },
  { to: "/recurring", label: "Recurring", icon: Repeat },
  { to: "/insights", label: "Insights", icon: Lightbulb },
  { to: "/financial-analysis", label: "Financial Analysis", icon: ClipboardList },
  { to: "/debt", label: "Debt Eliminator", icon: CreditCard },
  { to: "/payment", label: "Payment", icon: Wallet },
  { to: "/settings", label: SETTINGS_LABEL_COPY, icon: Settings },
];
